// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_component_tooltip__gx-0c","tooltipArrow":"tooltip_component_tooltipArrow__AxXPE"};